import React, { Component } from "react";
import "../App.css";
import TimerBanner from "../images/TimeBanner.png";
import CloseArrow from "../images/close_arrow.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

class PhilosophiesOfTime extends Component {
  state = {
    bookList: [
      {
        id: 1,
        title: "Scrum",
        author: "Jeff Sutherland",
        preview:
          "For those who believe that there must be a more agile and efficient way for people to get things done, here is a brilliantly discursive, thought-provoking book about the leadership and management process that is changing the way we live. In the future, historians may look back on human progress and draw a sharp line designating “before Scrum” and “after Scrum.” Scrum is that ground-breaking.  It already drives most of the world’s top technology companies. And now it’s starting to spread to every domain where leaders wrestle with complex projects.",
      },
      {
        id: 2,
        title: "15 Secrets",
        author: "Kevin Kruse",
        preview:
          "What if a few new habits could dramatically increase your productivity, and even 5x or 10x it in key areas? What if you could get an hour a day to read, exercise, or to spend with your family. New York Times bestselling author, Kevin Kruse, presents the remarkable findings of his study of ultra-productive people. Based on survey research and interviews with billionaires, Olympic athletes, straight-A students, and over 200 entrepreneurs—-including Mark Cuban, Kevin Harrington, James Altucher, John Lee Dumas, Pat Flynn, Grant Cardone, and Lewis Howes—-Kruse answers the question: what are the secrets to extreme productivity?",
      },
      {
        id: 3,
        title: "The Focus Project",
        author: "Equalman",
        preview:
          "Whether you’re an executive, a mom, a CEO, a teacher, or an entrepreneur...THIS BOOK IS FOR YOU IF: 1. You feel stretched too thin by trying to do too much.2. There’s no time for relaxation or deep thinking.3. You’re completing thousands of tasks without achieving your goals.Welcome to The Focus Project, a book designed to provide answers and solutions to the challenge of focusing in an unfocused world.",
      },
      {
        id: 4,
        title: "Mind Management",
        author: "David Kadavy",
        preview:
          "You have the TIME. Do you have the ENERGY? You’ve done everything you can to save time. Every productivity tip, every “life hack,” every time management technique. But the more time you save, the less time you have. The more overwhelmed, stressed, exhausted you feel. “Time management” is squeezing blood from a stone. Introducing a new approach to productivity. Instead of struggling to get more out of your time, start effortlessly getting more out of your mind. In Mind Management, Not Time Management, best-selling author David Kadavy shares the fruits of his decade-long deep dive into how to truly be productive in a constantly changing world.",
      },
      {
        id: 5,
        title: "The One Thing",
        author: "Gary Keller/ Jay Papasan",
        preview:
          "In The ONE Thing, you'll learn to * cut through the clutter * achieve better results in less time * build momentum toward your goal* dial down the stress * overcome that overwhelmed feeling * revive your energy * stay on track * master what matters to you The ONE Thing delivers extraordinary results in every area of your life--work, personal, family, and spiritual. WHAT'S YOUR ONE THING?",
      },
      {
        id: 6,
        title: "Time Management",
        author: "Julie Morgenstern",
        preview:
          "Applying the groundbreaking from-the-inside-out approach that made Organizing from the Inside Out a New York Times bestseller, Julie Morgenstern set a new standard for the time- management category. Her system has helped countless readers uncover their psychological stumbling blocks and strengths, and develop a time-management system that suits their individual needs.",
      },
      {
        id: 7,
        title: "Organize Tomorrow Today",
        author: "Dr. Jason Selk & Tom Bartow",
        preview:
          "In Organize Tomorrow Today (OTT), two of the top minds in human performance come together to deliver the pathway to extreme success: Doing more is not the answer, and Selk and Bartow walk you through how to achieve more by doing less.",
      },
      {
        id: 8,
        title: "Changes",
        author: "Michael Diettrich-Chastain",
        preview:
          "Why do people struggle with creating the changes they say they want? With over a decade of work with thousands of clients in the fields of organizational consulting, executive coaching and psychotherapy, author Michael Diettrich-Chastain reveals the seven life dimensions that impact our ability to make professional and personal changes...as well as why we succeed at making certain changes and fail at others. ",
      },
    ],
  };

  handleBook1Click = () => {
    document
      .getElementById("bump-out-1")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook2Click = () => {
    document
      .getElementById("bump-out-2")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook3Click = () => {
    document
      .getElementById("bump-out-3")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook4Click = () => {
    document
      .getElementById("bump-out-4")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook5Click = () => {
    document
      .getElementById("bump-out-5")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook6Click = () => {
    document
      .getElementById("bump-out-6")
      .classList.toggle("bump-out-slide-left");
  };

  handleBook7Click = () => {
    document
      .getElementById("bump-out-7")
      .classList.toggle("bump-out-slide-right");
  };

  handleBook8Click = () => {
    document
      .getElementById("bump-out-8")
      .classList.toggle("bump-out-slide-left");
  };

  render() {
    return (
      <div>
        <section className="time-banner-wrapper">
          <img className="Time-Banner" src={TimerBanner} alt="timebanner"></img>
          <div>
            <h1>Philosophies of Time</h1>
            <p>
              Take a moment and relax with these award winning titles and sink
              into time itself
            </p>
          </div>
        </section>
        <section className="time-grid-container">
          <div className="grid-title">
            <h1>Popular Titles</h1>
            <input type="search" placeholder="search titles"></input>
          </div>

          {/* Book 1 */}
          <div className="bumpout-animation-wrapper book-1-position">
            <div id="bump-out-1" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[0].title}</h2>
                <h2>Author: {this.state.bookList[0].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[0].preview}
                </h2>
              </div>
              <a
                className="findIt"
                href="https://www.amazon.com/Scrum-Doing-Twice-Work-Half/dp/038534645X"
                target="_blank"
              >
                <button className="find-button" href="#" target="_blank">
                  Find It
                </button>
              </a>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook1Click}
              />
            </div>
            <div
              className="time-book1-cover book1-style"
              onClick={this.handleBook1Click}
            ></div>
          </div>

          {/* Book 2 */}
          <div className="bumpout-animation-wrapper book-2-position">
            <div id="bump-out-2" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[1].title}</h2>
                <h2>Author: {this.state.bookList[1].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[1].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook2Click}
              />
            </div>
            <div
              className="time-book2-cover book2-style"
              onClick={this.handleBook2Click}
            ></div>
          </div>

          {/* Book 3 */}
          <div className="bumpout-animation-wrapper book-3-position">
            <div id="bump-out-3" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[2].title}</h2>
                <h2>Author: {this.state.bookList[2].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[2].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="time-book3-cover book3-style"
              onClick={this.handleBook3Click}
            ></div>
          </div>

          {/* Book 4 */}
          <div className="bumpout-animation-wrapper book-4-position">
            <div id="bump-out-4" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[3].title}</h2>
                <h2>Author: {this.state.bookList[3].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[3].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="time-book4-cover book4-style"
              onClick={this.handleBook4Click}
            ></div>
          </div>

          {/* Book 5 */}
          <div className="bumpout-animation-wrapper book-5-position">
            <div id="bump-out-5" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[4].title}</h2>
                <h2>Author: {this.state.bookList[4].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[4].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook3Click}
              />
            </div>
            <div
              className="time-book5-cover book5-style"
              onClick={this.handleBook5Click}
            ></div>
          </div>

          {/* Book 6 */}
          <div className="bumpout-animation-wrapper book-6-position">
            <div id="bump-out-6" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[5].title}</h2>
                <h2>Author: {this.state.bookList[5].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[5].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook4Click}
              />
            </div>
            <div
              className="time-book6-cover book6-style"
              onClick={this.handleBook6Click}
            ></div>
          </div>

          {/* Book 7 */}
          <div className="bumpout-animation-wrapper book-7-position">
            <div id="bump-out-7" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[6].title}</h2>
                <h2>Author: {this.state.bookList[6].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[6].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-left"
                src={CloseArrow}
                onClick={this.handleBook7Click}
              />
            </div>
            <div
              className="time-book7-cover book7-style"
              onClick={this.handleBook7Click}
            ></div>
          </div>

          {/* Book 8 */}
          <div className="bumpout-animation-wrapper book-8-position">
            <div id="bump-out-8" className="bump-out">
              <div className="bump-out-content-wrapper">
                <h2>Title:{this.state.bookList[7].title}</h2>
                <h2>Author: {this.state.bookList[7].author}</h2>
                <h2>
                  Rating:{" "}
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                  <FontAwesomeIcon icon={["fas", "heart"]} color="#ffa1b8" />
                </h2>
                <h2 className="text-alignment">
                  Preview:
                  <br />
                  <br />
                  {this.state.bookList[7].preview}
                </h2>
              </div>
              <button className="find-button" href="#" target="_blank">
                Find It
              </button>
              <a href="#" className="add-to-list">
                Add to List
              </a>
              <img
                className="close-bump-out-right"
                src={CloseArrow}
                onClick={this.handleBook8Click}
              />
            </div>
            <div
              className="time-book8-cover book8-style"
              onClick={this.handleBook8Click}
            ></div>
          </div>
        </section>
      </div>
    );
  }
}

export default PhilosophiesOfTime;
